import React, { useState, useEffect } from 'react';
import { signInWithEmailAndPassword, createUserWithEmailAndPassword, sendPasswordResetEmail, updatePassword, signOut } from 'firebase/auth';
import { auth, db } from './firebase';
import { useNavigate } from 'react-router-dom';
import { doc, setDoc } from 'firebase/firestore'; // Add setDoc to save user data
import FormulatorHeader from './FormulatorHeader.png';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [companyInitials, setCompanyInitials] = useState(''); // New state for initials
  const [isSignup, setIsSignup] = useState(false);
  const [isForgotPassword, setIsForgotPassword] = useState(false);
  const [resetEmail, setResetEmail] = useState('');
  const [resetMessage, setResetMessage] = useState('');
  const [isChangePassword, setIsChangePassword] = useState(false);
  const [changeEmail, setChangeEmail] = useState('');
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmNewPassword, setConfirmNewPassword] = useState('');
  const [changeMessage, setChangeMessage] = useState('');
  const navigate = useNavigate();

  console.log('Login component mounted');

  useEffect(() => {
    console.log('useEffect: isSignup changed to', isSignup);
  }, [isSignup]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (isSignup) {
        if (!companyInitials || !/^[A-Z]{2,3}$/.test(companyInitials)) {
          alert('Please enter valid company initials (2-3 uppercase letters).');
          return;
        }
        try {
        const userCredential = await createUserWithEmailAndPassword(auth, email, password);
        const user = userCredential.user;
          console.log('User created:', user.uid);
        await setDoc(doc(db, 'users', user.uid), {
          email: user.email,
            companyInitials: companyInitials.toUpperCase(),
          createdAt: new Date().toISOString()
        }, { merge: true });
          console.log('User document saved');
        } catch (error) {
          console.error('Sign-up error:', error);
          let message = error.message;
          if (error.code === 'auth/email-already-in-use') {
            message = 'This email is already registered. Try logging in.';
          } else if (error.code === 'auth/weak-password') {
            message = 'Password should be at least 6 characters.';
          } else if (error.code === 'permission-denied') {
            message = 'Insufficient permissions to save user data. Contact support.';
          }
          alert('Sign-up failed: ' + message);
          return;
        }
      } else {
        await signInWithEmailAndPassword(auth, email, password);
      }
      navigate('/');
    } catch (error) {
      console.error(error.message);
      alert(error.message);
    }
  };

  const handleForgotPassword = async () => {
    if (!resetEmail) {
      setResetMessage('Please enter your email.');
      return;
    }
    try {
      await sendPasswordResetEmail(auth, resetEmail);
      setResetMessage('Password reset email sent! Check your inbox.');
      setIsForgotPassword(false);
    } catch (error) {
      setResetMessage('Error: ' + error.message);
    }
  };

  const handleChangePassword = async () => {
    if (!changeEmail || !oldPassword || !newPassword || !confirmNewPassword) {
      setChangeMessage('Please fill all fields.');
      return;
    }
    if (newPassword !== confirmNewPassword) {
      setChangeMessage('New passwords do not match.');
      return;
    }
    try {
      const credential = await signInWithEmailAndPassword(auth, changeEmail, oldPassword);
      await updatePassword(credential.user, newPassword);
      await signOut(auth);
      setChangeMessage('Password changed successfully! You can now log in with your new password.');
      setIsChangePassword(false);
    } catch (error) {
      setChangeMessage('Error: ' + error.message);
    }
  };

  console.log('Rendering Login - isSignup:', isSignup, 'email:', email, 'password:', password, 'companyInitials:', companyInitials);
  return (
    <>
      <img src={FormulatorHeader} alt="Formulator Header" style={{ display: 'block', margin: '20px auto', maxWidth: '80%' }} />
      <div style={{ maxWidth: '300px', margin: '0 auto', padding: '20px', backgroundColor: '#373636', color: '#fff', border: '1px solid #ccc', borderRadius: '8px' }}>
        <h2>{isSignup ? 'Sign Up' : 'Login'}</h2>
        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
          <div>Enter Email</div>
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" style={{ padding: '8px', backgroundColor: '#fff', color: '#000', fontSize: '16px' }} />
          <div>Enter Password</div>
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" style={{ padding: '8px', backgroundColor: '#fff', color: '#000', fontSize: '16px' }} />
          {isSignup && (
            <>
              <div>Enter Your Company Name</div>
              <input type="text" value={companyInitials} onChange={(e) => setCompanyInitials(e.target.value)} maxLength="3" placeholder="Company Name" style={{ padding: '8px', backgroundColor: '#fff', color: '#000', fontSize: '16px' }} />
            </>
          )}
          <button type="submit" style={{ padding: '10px', backgroundColor: '#007bff', color: '#fff' }}>{isSignup ? 'Sign Up' : 'Login'}</button>
        </form>
        {!isSignup && !isForgotPassword && !isChangePassword && (
          <button type="button" onClick={() => setIsChangePassword(true)} style={{ marginTop: '10px', background: 'none', border: 'none', color: 'yellow', textDecoration: 'underline', cursor: 'pointer' }}>
            Change Password
          </button>
        )}
        {isForgotPassword && (
          <div>
            <input
              type="email"
              value={resetEmail}
              onChange={(e) => setResetEmail(e.target.value)}
              placeholder="Enter your email"
              style={{ display: 'block', margin: '10px 0' }}
            />
            <button type="button" onClick={handleForgotPassword}>Send Reset Email</button>
            <button type="button" onClick={() => setIsForgotPassword(false)} style={{ marginLeft: '10px' }}>Cancel</button>
            {resetMessage && <p>{resetMessage}</p>}
          </div>
        )}
        {isChangePassword && (
    <div>
        <input
          type="email"
              value={changeEmail}
              onChange={(e) => setChangeEmail(e.target.value)}
          placeholder="Email"
          style={{ display: 'block', margin: '10px 0' }}
        />
        <input
          type="password"
              value={oldPassword}
              onChange={(e) => setOldPassword(e.target.value)}
              placeholder="Old Password"
              style={{ display: 'block', margin: '10px 0' }}
            />
            <input
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              placeholder="New Password"
          style={{ display: 'block', margin: '10px 0' }}
        />
          <input
              type="password"
              value={confirmNewPassword}
              onChange={(e) => setConfirmNewPassword(e.target.value)}
              placeholder="Confirm New Password"
            style={{ display: 'block', margin: '10px 0' }}
          />
            <button type="button" onClick={handleChangePassword}>Change Password</button>
            <button type="button" onClick={() => setIsChangePassword(false)} style={{ marginLeft: '10px' }}>Cancel</button>
            {changeMessage && <p>{changeMessage}</p>}
          </div>
        )}
        <button onClick={() => {
          const newMode = !isSignup;
          setIsSignup(newMode);
          console.log('Button clicked - Setting isSignup to:', newMode);
        }} style={{ marginTop: '20px', padding: '10px', backgroundColor: '#6c757d', color: '#fff', width: '100%' }}>
        {isSignup ? 'Switch to Login' : 'Switch to Sign Up'}
      </button>
    </div>
    <div style={{ maxWidth: '600px', margin: '20px auto', padding: '20px', backgroundColor: '#373636', color: '#fff', border: '1px solid #ccc', borderRadius: '8px', textAlign: 'center' }}>
      <h3>Welcome to the Kingfisher Stain Formulator</h3>
      <p style={{ fontSize: '16px', lineHeight: '1.6', marginBottom: '15px' }}>
        This app is currently in <strong>beta</strong> and designed to streamline the stain formulation process using the Sivam Kingfisher Stain System for wood finishing professionals.
      </p>
      <ul style={{ fontSize: '14px', lineHeight: '1.5', color: '#ccc', textAlign: 'left', maxWidth: '500px', margin: '0 auto', paddingLeft: '20px' }}>
        <li>Create, save, and manage custom stain formulas with precise ingredient measurements</li>
        <li>Automatic cost calculations and professional PDF export capabilities</li>
        <li>Track your formulations by customer, wood species, and project details</li>
        <li>Maintain a comprehensive library of your stain recipes</li>
      </ul>
    </div>
    </>
  );
}

export default Login;